import { Dialog, ThemeProvider } from '@sparemin/blockhead';
import { MediaImporter, MediaImporterProps } from '@sparemin/media-import';
import React from 'react';
import LoadingOverlay from 'components/LoadingOverlay';
import { UseConnectedModalReturnType } from 'containers/ConnectedModal/useConnectedModal';
import { MediaUploadContext } from 'utils/constants';
import useMediaUploadModal from './useMediaUploadModal';
import { block } from './utils';

export interface MediaImporterOverlayProps
  extends Pick<UseConnectedModalReturnType, 'onHide'> {
  uploadContext: MediaUploadContext;
  mediaImporterProps: Omit<
    MediaImporterProps,
    'onMediaImported' | 'onMediaAccepted' | 'onMediaRejected' | 'onAuthError'
  >;
}

const MediaImporterOverlay: React.FC<MediaImporterOverlayProps> = ({
  uploadContext,
  mediaImporterProps,
  onHide,
}) => {
  const {
    isLoadingFile,
    mediaImporterDefaults,
    mediaImporterCallbacks,
  } = useMediaUploadModal({
    uploadContext,
    onHide,
  });

  return (
    <ThemeProvider theme="dark">
      <div className={block('contents')}>
        <Dialog.CloseButton
          onPress={() => onHide()}
          className={block('close-button')}
        />

        {isLoadingFile && <LoadingOverlay />}

        <MediaImporter
          {...mediaImporterDefaults}
          {...mediaImporterCallbacks}
          {...mediaImporterProps}
        />
      </div>
    </ThemeProvider>
  );
};

export default MediaImporterOverlay;
